
var id = "commodity";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18 14\" id=\"commodity\">\n<style type=\"text/css\">\n\t#commodity .st0{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<title>icon/maps/local_activity_24px</title>\n<g id=\"commodity_商品管理V2\">\n\t<g id=\"commodity_商品详情\" transform=\"translate(-28.000000, -441.000000)\">\n\t\t<g id=\"commodity_left-menu-sidebar\" transform=\"translate(0.000000, 64.000000)\">\n\t\t\t<g id=\"commodity_Group-4-Copy\" transform=\"translate(0.000000, 360.000000)\">\n\t\t\t\t<g transform=\"translate(28.000000, 17.000000)\">\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<path class=\"st0\" d=\"M15.8,7c0-1,0.8-1.8,1.8-1.8V1.8c0-1-0.8-1.8-1.8-1.8h-14C0.8,0,0,0.8,0,1.8v3.5C1,5.2,1.8,6,1.8,7\n\t\t\t\t\t\t\tS1,8.8,0,8.8v3.5c0,1,0.8,1.8,1.8,1.8h14c1,0,1.8-0.8,1.8-1.8V8.8C16.5,8.8,15.8,8,15.8,7z M11.9,11.2l-3.1-2l-3.1,2l0.9-3.6\n\t\t\t\t\t\t\tL3.7,5.2L7.4,5l1.4-3.4L10.1,5l3.7,0.2l-2.9,2.4L11.9,11.2z\" />\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
